<style lang="less" scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
</style>

<template>
<div>
    <Modal
        class-name="vertical-center-modal"
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'700px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem :label="$t('deviceManage.manageModel.sname')" prop="groupName"  style="width: 500px">
                 <Input type="text" v-model.trim="formData.groupName" maxlength="50"  show-word-limit :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

            <FormItem :label="$t('deviceManage.manageModel.remark')" prop="remark"  style="width: 500px">
                 <Input  maxlength="100" show-word-limit type="textarea" v-model.trim="formData.remark" :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

            <FormItem>
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import { mapState } from 'vuex'

    export default {
        props: {
            showModel: Boolean,
            fn:Function
        },
        name: "SModel3",
        components: {
        },
        data() {
            return {   
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                    groupName: '',
                    remark:''
                }
            }
        },
        watch:{
            showModel(val){
                if(val){
                    
                }
            }
        },
        computed:{
            ...mapState(['local','selectId']),
            ruleCustom(){
                return {//验证
                    groupName: [
                        {required: true, type: 'string', message: this.$t('required'),trigger: 'change' },
                    ]
                }
            }

        },
        created(){
         
        },
        methods: {
            openOrClose(value) {
                if(value === true) {    
                    this.title = this.$t('deviceManage.manageModel.stitle')
                } else { //关闭弹框后要做的处理
                    this.fn()
                    this.resetForm();//重置表单
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;

                        this.axios.post(this.config.urlArray.userGroupAdd, {...this.formData,dealerId:this.selectId}).then((result) => {
                            // console.log(result.data)
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false; })
                            
                        }).catch((err) => {
                            // common.msg('error','提交失败',()=>{this.disabled = false;})
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.fn()
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                this.$refs.formData.resetFields();//重置表单
            }
        }
    }
</script>
